import { cloneElement, useState, useRef, useEffect } from '@wordpress/element';

const RelatedContentProvider = ({
    pageIds,
    children,
    ...props
}) => {
    const [ model, setModel ] = useState({
        categories: [],
        pages: []
    });
    const [ navigationProps, setNavigationProps ] = useState({
        hasNavigation: false,
        prevDisabled: true,
        nextDisabled: false
    });
    const [ isLoading, setLoading ] = useState(true);
    const sliderContainerRef = useRef(null);

    useEffect(() => {
        const fetchSavedPages = async () => {
            setLoading(true);
            try {
                //Get language from url.
                const pathName = window.location.pathname;
                const language = pathName.substring(0, 3).replace('/', '');

                let categories = model.categories;
                if (model.categories.length === 0 ) {
                    const resTaxonomy = await fetch(`/wp-json/wp/v2/typ?lang=${language}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });

                    if (!resTaxonomy.ok) {
                        throw new Error(`Response status: ${resTaxonomy.status}`);
                    }
                 
                    categories = await resTaxonomy.json();
                }

                const allResponses = await Promise.all(pageIds.map(post => {
                    let type = post.subtype === 'page' ? 'pages' : post.subtype;
                    return fetch(`/wp-json/wp/v2/${type}/${post.id}?_embed`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                }));

                const fullContent = await Promise.all(allResponses.map(response => {
                    return response.json();
                }));

                setModel({
                    ...model,
                    pages: fullContent,
                    categories
                });
                setLoading(false);
            } catch (e) {
                console.log(e);
            }
		};
		if (pageIds?.length > 0) {
			fetchSavedPages();
		} else {
            setModel({
                ...model,
                pages: []
            });
        }
    }, [pageIds]);

    useEffect(() => {
        if (pageIds && pageIds.length > 0 && !isLoading && sliderContainerRef) {
            const container = sliderContainerRef.current;
            const containerDimensions = container.getBoundingClientRect();
            const containerWidth = Math.round(containerDimensions.width);
            const fullWidth = Math.round(container.scrollWidth);

            if (fullWidth > containerWidth) {
                setNavigationProps({
                    ...navigationProps,
                    hasNavigation: true,
                    prevDisabled: true
                });

                container.addEventListener('scrollend', () => {
                    setNavigationProps({
                        ...navigationProps,
                        hasNavigation: true,
                        prevDisabled: Math.round(container.scrollLeft) <= 0,
                        nextDisabled: (Math.round(container.scrollLeft) + Math.round(container.clientWidth)) >= Math.round(container.scrollWidth)
                    });
                });
            }
        }
    }, [pageIds, isLoading, sliderContainerRef]);

    const nextPage = () => {
        const container = sliderContainerRef.current;
    
        container.scrollBy({
            left: Math.round(container.clientWidth), 
            top: 0, 
            behavior: 'smooth'
        });

        const nextPageAfterScroll = Math.round(container.scrollLeft)+(Math.round(container.clientWidth)*2);

        setNavigationProps({
            ...navigationProps,
            prevDisabled: false,
            nextDisabled: nextPageAfterScroll >= Math.round(container.scrollWidth)
        });
    }

    const prevPage = () => {
        const container = sliderContainerRef.current;
    
        container.scrollBy({
            left: Math.round(container.clientWidth) * -1, 
            top: 0, 
            behavior: 'smooth'
        });

        setNavigationProps({
            ...navigationProps,
            prevDisabled: (Math.round(container.scrollLeft) - Math.round(container.clientWidth)) < 0,
            nextDisabled: false
        });
    };
    
    return cloneElement(children, {
        ...props,
        ...model,
        pageIds,
        isLoading,
        sliderContainerRef,
        navigationProps,
        nextPage,
        prevPage
    });
};

export default RelatedContentProvider;